import { usePaginatedQuery } from 'hooks/usePaginatedQuery'
import { TLoginHistoryList } from 'shared/types'
import { api } from '..'

export const getLoginHistory = (params?: Record<string, string>) =>
  api
    .get<TLoginHistoryList>('/v1/login-history', {
      params,
    })
    .then(({ data }) => data)

export const loginHistoryQuery = (params?: Record<string, string>) => ({
  queryFn: () => getLoginHistory(params),
  queryKey: ['login-history', params],
})

export const useGetLoginHistory = () => usePaginatedQuery(loginHistoryQuery)
